import { render } from "./ItalicAction.vue?vue&type=template&id=74cd4750"
import script from "./ItalicAction.vue?vue&type=script&lang=js"
export * from "./ItalicAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__